import { DataSelectors } from "@app/store/data/data.selectors";
import { SlideUpWindowByStudentState } from "./slide-up-window-by-student.state";
import { Store } from "@ngxs/store";
import { DialogData } from "@app/shared/components/confirm-dialog/confirm-dialog.component";
import { DialogService } from "@app/services/dialog.service";

function buildContent(store: Store, state: SlideUpWindowByStudentState) {
    let result = '';
    for (let key of Object.keys(state.selectedRoomIdsByUser)) {
        const careConneCareConneRoomListByUser = store.selectSnapshot(DataSelectors.careConneRoomList(key));
        result += `<li style='padding-left: 1rem;max-height: 10rem;overflow: auto;font-weigt: bold'>`;
        const roomListByUser = careConneCareConneRoomListByUser.roomDataByUnit.flatMap((item) => item.rooms);
        const roomInfos = state.selectedRoomIdsByUser[key].roomIds.map((roomId) => {
            const foundRoom = roomListByUser.find((room) => room.roomId === roomId);
            return foundRoom;
        });
        const userName = careConneCareConneRoomListByUser?.name;
        result += userName;
        const sendToRooms = roomInfos.map((room) => `<ul style='padding-left: 2rem;max-height: 10rem;overflow: auto;'>${room?.name}</ul>`).join('');
        result += sendToRooms;
        result += '</li>';
    }
    return result;
}

export function createRoomConfirm(
    store: Store, 
    state: SlideUpWindowByStudentState, 
    message: string, 
    dialogService: DialogService
) {
    const content = `
    <section style="
    display: flex;
    flex-direction: column;
    font-weight: 300;
    gap: 0.5rem;
    font-size: 0.875rem;
    ">
      <p>下記の内容でケアコネに送信します。</p>

      <span>送信先</span>
      ${buildContent(store, state)}

      <span>メッセージ</span>
      <span style="padding-left: 1rem;width: 100%;overflow-wrap: break-word;max-height: 10rem;overflow: auto;">
       ${message.toString()}
      </span>
    </section>
    `;

    const confirmData: DialogData = {
        cancelText: 'いいえ',
        excuteText: 'はい',
        content: `${content}`,
        style: {
            'display': 'flex',
            'flexDirection': 'column',
            'gap': '0.5rem',
            'font-weight': '300'
        }

    };
    return dialogService.confirm(confirmData);
}
